import React, { useContext } from "react";
import { Pagination, Select, Input } from "antd";
import { AiFillCloseCircle } from "react-icons/ai";
import { BsSearch } from "react-icons/bs";
import {
  FIELD_MARGIN_RIGHT,
  FIELD_WIDTH,
  FIELD_WIDTHS,
} from "../../config/layoutConfig";
import { VILLAGES } from "../../constants/constants";
import { ENTITIES, SERVICES } from "../../entities/entitiesConfig";
import { AppContext } from "../../context";
import "./HomeFilter.css";
import UrbanMobilityText from "../../entities/rentacar/components/UrbanMobilityText";

function HomeFilter({ setOpenFilter, setProducts, setStores, setCount, page }) {
  const info = useContext(AppContext);

  const servicesOptions = () => {
    return Object.keys(ENTITIES).flatMap((ent) =>
      ENTITIES[ent].label && ENTITIES[ent].showInHomeMenu
        ? {
            value: ent,
            label: (
              <div className="ahp-bold-item">
                {ENTITIES[ent].icon} {info.t(ENTITIES[ent].label)}
              </div>
            ),
          }
        : []
    );
  };

  return (
    <div className="ahp-main-filter-h">
      <div
        className="ahp-close-filter"
        onClick={() => {
          // setType(null);
          // setVillages([]);
          info.setType(null);
          info.setVillages([]);
          setOpenFilter(false);
        }}
      >
        <AiFillCloseCircle size={20} />
        {/* Limpar Filtro */}
      </div>
      <BsSearch
        className="ahp-mag-lens"
        size={20}
        style={{ marginTop: 10, marginRight: 10 }}
      />
      <div>
        <div className="ahp-select-border">
          <Select
            className="ahp-service-name"
            placeholder={info.t("reserve")}
            options={servicesOptions()}
            value={info?.type || undefined}
            onChange={(value) => {
              info?.setType(value);
              setOpenFilter(true);
            }}
            style={
              {
                // width: FIELD_WIDTHS.XL + 10,
                // marginLeft: 0,
                // marginRight: FIELD_MARGIN_RIGHT,
              }
            }
            dropdownMatchSelectWidth={false}
            showArrow={false}
            bordered={false}
          />
        </div>
        {info.type === "rentacar" && <UrbanMobilityText />}
      </div>
      {(!info?.type || ENTITIES[info?.type]?.hasVillagesSearch) &&
        ENTITIES[info?.type]?.showInHomeMenu && (
          <div>
            <div className="ahp-select-border">
              <Select
                className="ahp-service-name"
                placeholder={info.t("villages")}
                options={VILLAGES}
                value={info?.villages || undefined}
                onChange={(value) => {
                  info.setCommonFilter({
                    ...info.commonFilter,
                    villages: value,
                  });
                  info.setVillages(value);
                  setOpenFilter(true);
                }}
                style={{
                  minWidth: FIELD_WIDTHS.S,
                  // marginRight: FIELD_MARGIN_RIGHT,
                }}
                dropdownMatchSelectWidth={false}
                showArrow={false}
                bordered={false}
                mode="multiple"
                maxTagCount={2}
              />
            </div>
          </div>
        )}
      {(!info?.type || ENTITIES[info?.type]?.hasNameSearch) &&
        ENTITIES[info?.type]?.showInHomeMenu && (
          <div>
            <div className="ahp-select-border">
              <Input
                // showSearch
                className="ahp-business-name"
                placeholder={info.t("business_name")}
                style={{
                  // width: (2 / 3) * FIELD_WIDTH,
                  marginTop: 2,
                  color: "black",
                  textAlign: "center",
                  // width: "100%",
                }}
                value={info?.name}
                onChange={
                  // setName
                  (e) => {
                    info.setCommonFilter({
                      ...info.commonFilter,
                      name: e.target.value,
                    });
                    info.setName(e.target.value);
                    // setName(e.target.value);
                    setOpenFilter(true);
                  }
                }
                // notFoundContent={null}
                bordered={false}
              ></Input>
            </div>
          </div>
        )}
      {info?.type &&
        page &&
        React.createElement(ENTITIES[info.type].HomeFilter, {
          type: info.type,
          name: info.name,
          villages: info.villages,
          setProducts,
          setStores,
          page,
        })}
    </div>
  );
}

export default React.memo(HomeFilter);
